module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ZzGfII/images/cover.jpeg?1712294946814",
      "alt": "This image is the cover for the book Something Epic Vol. 1, Something Epic"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Something Epic Vol. 1, Something Epic\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("IMAGINATION IS REAL. Outside our perception, creative thought takes physical form, with only a handful of individuals known as Epics able to interact with this wondrous hidden world. But for fourteen-year-old Danny Dillon, accepting these responsibilities himself won’t be easy-or safe. Lose yourself in a world of endless fantasy and creativity, where superheroes, monsters, magical creatures, and cartoon characters live and breathe alongside us. Fan-favorite Spawn and Punisher artist SZYMON KUDRANSKI introduces a world where the only limitation is your imagination. Collects groundbreaking hit series SOMETHING EPIC #1-7 “Szymon Kudranski’s Something Epic is a breath-taking book that holds one of the most powerful messages for humanity.“ - CBR.COM “If you are a fan of strange stories and emotionally laced adventures, this is a comic you are not going to want to miss.“ - Comicon.com 10/10 “Something Epic is an experience that truly lives up to it’s name.“ - thegww.com 9.5/10 “Something Epic is a comic written for all those who have looked to their imagination to escape the world around them.“ aiptcomics.com 9/10")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Szymon Kudrański, Szymon Kudrański\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Image Comics\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0